import { createBrowserRouter, Outlet, ScrollRestoration, useLocation, useNavigate } from "react-router-dom"

import { useEffect, type ReactNode } from "react";
import { ensureScrollRestoration } from "./utils/common.js";
import { HomePage } from "./pages/home/HomePage.js";
import PageError from "./pages/PageError.js";
import { CustomDeckCoverPage } from "./pages/custom-deck-cover/CustomDeckCoverPage.js";
import { CustomDeckCoverListPage } from "./pages/custom-deck-cover/CustomDeckCoverListPage.js";

declare global {
  interface Window {
    gd?: {
      navigate?: ReturnType<typeof useNavigate>;
    };
  }
}

const gd = window.gd || {};

function WapperNavigate({ children }: { children: ReactNode }) {

  ensureScrollRestoration()

  const navigate = useNavigate()
  // const { handleWechatAuth } = useWechatAuth()
  if (gd.navigate !== navigate) {
    gd.navigate = navigate
  }
  window.gd = gd

  let location = useLocation();
  console.log('router-28行 2024-12-25', location)

  useEffect(() => {
    // handleWechatAuth()
  }, [location?.pathname])

  return children;
}

// ========== 公共路由 ==========
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <WapperNavigate>
        <Outlet />
        <ScrollRestoration />
      </WapperNavigate>
    ),
    errorElement: <PageError />,
    children: [
      // ========== 首页 ==========
      { path: "/", element: <HomePage />, },
      { path: "/custom-deck-cover", element: <CustomDeckCoverPage />, },
      { path: "/custom-deck-cover/list", element: <CustomDeckCoverListPage />, },
    ],
  },
]);

export default router